import GreenAudioPlayer from "./vendor/green-audio-player.min.js";

(function() {
	'use strict';

    var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

    jQuery(document).ready(function($) {
        if($('.coach-signup').length) {
            var signupVue = new Vue({el: '.coach-signup'});
        }
        if($('.signup-content').length) {
            var signupVue = new Vue({el: '.signup-content'});
        }
        if($('.coach-profile').length) {
            var profileVue = new Vue({el: '.coach-profile'});
        }
        if($('.coach-settings').length) {
            var settingsVue = new Vue({el: '.coach-settings'});
        }

        // Activate profile functions
        window.profile.editModal();

        // Add HTML classes for conditional CSS
        if (supportsTouch) {
            $('html').addClass('is-touch');
        } else {
            $('html').addClass('no-touch');
        }

        if ($('body.single-post').length) {
            // check if the paywall plugin is loaded and then run checkArticle
            if (typeof rmgPaywall !== 'undefined') {
                rmgPaywall.checkArticle(themevars.post_id, {}, function (access, context) {
                    // do nothing because there is no paywall but the function is needed for the correct dap data values
                });
            }
        }

        $('form.js-submit-on-change').on('change', ':input', function(e) {
            $(e.delegateTarget).trigger( "submit" );
        });

        // coach profile submit trigger
        $( "#contact-contact-submit" ).on('click', function() {
            $( "#contact-contact-form" ).trigger( "submit" );
        });

        $( "#contact-question-submit" ).on('click', function() {
            $( "#contact-question-form" ).trigger( "submit" );
        });

        //formulieren inschrijving voor coaches
        if( $( '.coach-signup' ).length || $( '.signup-content' ).length) {

            //disable button until all checkboxes are checked
            if( $( '.required' ).length ) {
                var $checks = $( '.required' ).on('change', function () {
                    $( 'button' ).prop( 'disabled', $checks.is(':not(:checked)') );
                } );
            }
        }



        // Replace input[type="date"] with a simple datepicker (quickfix)
        (function() {
            var $dob = $('input[name="day_of_birth"]');
            if (! $.fn.datepicker) {
                console.warn('Datepicker is missing');
                return;
            }
            $('#dayOfBirth_datepicker').datepicker({
                altField: $dob,
                altFormat: 'yy-mm-dd',
                dateFormat: 'dd-mm-yy'
            })
            .on('change', function() {
                var dateRegex = /^\d{2}-\d{2}-\d{4}$/;
                var value = $(this).val();

                if (! dateRegex.test(value)) {
                    $dob.val(value); // Honour manual user input
                }
            });
        })();


        //clickable div
        $(document).on('click', '[data-href]', function(e) {
            if (! $(e.target).is('a, button')) {
                window.location = $(this).data('href');
                e.preventDefault();
            }
        });

        $(document).on('click', '[data-goto-url]', function(e) {
            var url = $(this).data('goto-url');
            if(url) {
                window.location.href = url;
            }
        });

        //tooltip
        //$('[data-toggle="tooltip"]').tooltip()


        $(document).on('click', '[data-toggle="lightbox"]', function(event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                onShown: function() {
                    var lightbox = this;
                    // close lightbox if you click on the background
                    $('.ekko-lightbox-item.show').on('click', function(e) {
                        // check if you clicked on the background element and not one of the children (for example the prev/next links)
                        if(e.target == this) {
                            lightbox.close();
                        }
                    });
                }
            });
        });

        $(document).on('click', '[name="associations[]"]', function(e) {
            var checkedNothing = jQuery('input[name="associations[]"][value="geen"]');
            var checkboxChoices = jQuery('input[name="associations[]"]');

            if ($(this).is(checkedNothing)) {
                checkboxChoices.not(checkedNothing).attr('checked', false);
            } else {
                checkedNothing.attr('checked', false);
            }
        });

        // Add/remove checkbox values to select fields
        $(document).on('click', '.coach-profile [name="features[]"]', function(e) {
            if(this.checked) {
                $(".highlighted_feature_field").append( $("<option></option>").attr( "value", $(this).val() ).text( $(this).next('span').text() ) );
            } else {
                $(".highlighted_feature_field option[value=" + $(this).val() + "]").remove();
            }
        });

        /**
         * Focus on (possible) active subnav item
         */
         (function(){
            var $subNav = $('.topbar__subnav');
            var $currentItem = $subNav.find('.current-menu-item');

            if ($currentItem.length === 0) {
                return;
            }

            $subNav.scrollLeft($currentItem.position().left - parseInt($currentItem.css('paddingLeft')));
        })();

        if( $( '.ready-player' ).length ) {
            new GreenAudioPlayer('.ready-player', { stopOthersOnPlay: true, showDownloadButton: false });
        }

        if( $( '.ready-player-mob' ).length ) {
            new GreenAudioPlayer('.ready-player-mob', { stopOthersOnPlay: true, showDownloadButton: false });
        }

        // Show filename in custom upload button
        $('form').on('change', 'input[type="file"]', function(e) {
            var fileName = e.target.value.split('\\').pop();
            var $customButton = $(this).siblings('.button');
            if ($customButton.length > 0 && fileName) {
                $customButton.text(fileName);
            }
        });

        $('#mobile-nav').on('shown.bs.collapse', function () {
            $('#mobile-nav').animate({marginRight: '0px'}, 250);
        });

        $('#mobile-nav').on('hide.bs.collapse', function () {
            $('#mobile-nav').animate({marginRight: '-330px'}, 250);
        });


        // Set show/hide promotion in coach profile with checkboxes
        var promoBusy  = 0;
        var promoCheck = function($el) {
            if (!promoBusy) {
                promoBusy = 1;

                $el.parents('form.api-form').map(function() {
                    var data = new FormData(this);
                    var api_route = $(this).data('api-route');

                    $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + cfpluginvars.bearer_token);
                        },
                        url: cfpluginvars.api_uri + api_route,
                        data: data,
                        processData: false,
                        contentType: false,
                    }).done(function(result) {
                        promoBusy = 0;
                    });
                });
            }
        }

        $(document).on('change', 'input[name="show_in_profile"]', function(e) {
            var $el = $(this);
            promoCheck($el);
        });

        //Disable submit button on doc forms
        $('form.disable-on-submit').on('submit', function() {
            $(this).find(':button[type=submit]').prop('disabled', true);
        });
    });
})();
